__turbopack_context__.v({
  "columnHead": "ItemTable-module__idsL4a__columnHead",
  "columns-1": "ItemTable-module__idsL4a__columns-1",
  "columns-2": "ItemTable-module__idsL4a__columns-2",
  "columns-3": "ItemTable-module__idsL4a__columns-3",
  "columns-4": "ItemTable-module__idsL4a__columns-4",
  "columns-5": "ItemTable-module__idsL4a__columns-5",
  "columns-6": "ItemTable-module__idsL4a__columns-6",
  "head": "ItemTable-module__idsL4a__head",
  "root": "ItemTable-module__idsL4a__root",
});
